// @ts-nocheck
import { useState } from 'react';
import { Plus, Pencil, Trash2, Zap } from 'lucide-react';
import { toast } from 'sonner';
import { AI_AGENT_FIELD_LIMITS } from '@/utilities/constant';
import { c, Section, Empty, IconBtn, useNode } from '../ui';
import AddFunctionDialog from '../../../builder-components/AddFunctionDialog';
import CustomApiFunctionDialog from '../../../builder-components/CustomApiFunctionDialog';

const { API_MAX_ITEMS } = AI_AGENT_FIELD_LIMITS;

export default function FunctionsSection({ next, onNext, value, onChange }) {
  const functions = value ?? [];
  const node = useNode('functions');
  const [addOpen, setAddOpen] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const openCreate = () => {
    if (functions.length >= API_MAX_ITEMS) {
      toast.error(`You can add up to ${API_MAX_ITEMS} APIs`);
      return;
    }
    setEditing(null);
    setFormOpen(true);
  };
  const handleSave = (fn) => {
    const exists = functions.some((f) => f.id === fn.id);
    onChange?.(exists ? functions.map((f) => (f.id === fn.id ? fn : f)) : [...functions, fn]);
    toast.success(editing ? 'Function updated' : 'Function added');
  };

  return (
    <Section
      id="functions"
      icon={Zap}
      title="Functions"
      sub="Let the agent connect with other systems to get data or take action."
      tag={node.ok ? (functions.length ? 'set' : 'done') : 'optional'}
      ok={node.ok}
      next={next('functions')}
      onNext={onNext}
    >
      <div className={c('cnt')} style={{ margin: '0 0 10px' }}>
        <span>
          {functions.length} of {API_MAX_ITEMS} functions
        </span>
      </div>
      {functions.length === 0 ? (
        <Empty icon={Zap} title="No functions yet" text="Functions let the agent check an order or book a slot during a call." />
      ) : (
        functions.map((fn) => {
          const method = String(fn.method || fn.http_method || '').toUpperCase();
          const url = fn.url || fn.endpoint || '';
          return (
            <div className={c('item')} key={fn.id}>
              <span className={c('cb')} style={{ background: '#DCE3F0', color: 'var(--ink)' }}>
                <Zap className="ags-i" />
              </span>
              <div style={{ minWidth: 0 }}>
                <b>{fn.name}</b>
                {(method || url) && (
                  <p style={{ overflowWrap: 'anywhere' }}>
                    {method && <span className={c('m', method.toLowerCase())}>{method}</span>}
                    {url}
                  </p>
                )}
                {fn.description && <p>{fn.description}</p>}
              </div>
              <div className={c('acts')}>
                <IconBtn
                  icon={Pencil}
                  label={`Edit ${fn.name}`}
                  onClick={() => {
                    setEditing(fn);
                    setFormOpen(true);
                  }}
                />
                <IconBtn icon={Trash2} danger label={`Delete ${fn.name}`} onClick={() => onChange?.(functions.filter((f) => f.id !== fn.id))} />
              </div>
            </div>
          );
        })
      )}
      <div className={c('addrow')}>
        <button type="button" className={c('btn small')} onClick={() => setAddOpen(true)} disabled={functions.length >= API_MAX_ITEMS}>
          <Plus className="ags-i" />
          Add function
        </button>
      </div>
      <AddFunctionDialog open={addOpen} onOpenChange={setAddOpen} onCreateCustomApi={openCreate} />
      <CustomApiFunctionDialog open={formOpen} onOpenChange={setFormOpen} initial={editing} onSave={handleSave} />
    </Section>
  );
}
